import React from 'react'
import { Drawer, useTheme } from '@mui/material'
import { any, element } from 'prop-types'

const DesktopDrawer = ({ drawerWidth, children }) => {
  const theme = useTheme()
  const styles = {
    display: { xs: 'none', sm: 'block' },
    '& .MuiDrawer-paper': {
      boxSizing: 'border-box',
      width: drawerWidth,
      borderRadius: '0px 20px 20px 0px',
      backgroundColor: theme.palette.leitura.main,
      border: 'none!important',
      boxShadow: 'none'
    },
    '& .MuiDrawer-paper::-webkit-scrollbar-track': {
      backgroundColor: '#f5f5f5'
    },
    '& .MuiDrawer-paper::-webkit-scrollbar': {
      width: '6px',
      background: '#fff'
    },
    '& .MuiDrawer-paper::-webkit-scrollbar-thumb': {
      background: '#e4e4e4'
    }
  }

  return (
    <Drawer variant="permanent" sx={styles} open>
      {children}
    </Drawer>
  )
}

DesktopDrawer.propTypes = {
  drawerWidth: any,
  children: element
}

export default DesktopDrawer
